(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/teams-create.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/teams-create.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _svs$arena$pages$team = svs.arena.pages.teams.components,
  TeamsCreateName = _svs$arena$pages$team.TeamsCreateName,
  TeamsCreateInvite = _svs$arena$pages$team.TeamsCreateInvite;
const _svs$arena$pages$team2 = svs.arena.pages.teams.dialogs,
  showConfirmEmailDialog = _svs$arena$pages$team2.showConfirmEmailDialog,
  showTechnicalError = _svs$arena$pages$team2.showTechnicalError;
const checkAndShowSyndicateTermsDialogAsync = svs.syndicate.rules_and_terms.checkAndShowSyndicateTermsDialogAsync;
const teamsService = svs.arena.service.teamsService;
const TEAMS = svs.arena.constants.routes.TEAMS;
const contactInfoStatus = svs.arena.constants.contactInfoStatus;

const TeamsCreate = () => {
  const _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    createdTeamId = _React$useState2[0],
    setCreatedTeamId = _React$useState2[1];
  const history = useHistory();
  const _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isForbidden = _React$useState4[0],
    setIsForbidden = _React$useState4[1];
  const teams = ReactRedux.useSelector(state => state.teams.teams);
  const hasTeams = teams.length > 0;
  React.useEffect(() => {
    const redirectDependingOnStatus = () => {
      if (hasTeams) {
        history.push(TEAMS);
      } else {
        svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
      }
    };
    const checkEligibility = async () => {
      var _svs;
      const _await$teamsService$g = await teamsService.getPlayerEmailAsync(),
        emailData = _await$teamsService$g.data;
      if (svs.core.userSession.isBlocked()) {
        svs.accountservices.national_suspension_message.showNationalSuspensionCreateSyndicateMessageNew(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
        });
      } else if ((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.day_time_limit) !== null && _svs !== void 0 && (_svs = _svs.data) !== null && _svs !== void 0 && (_svs = _svs.dayTimeLimit) !== null && _svs !== void 0 && _svs.dayTimeExpired) {
        var _svs2;
        (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.day_time_limit) === null || _svs2 === void 0 || (_svs2 = _svs2.notices) === null || _svs2 === void 0 || _svs2.createSyndicate(() => {
          redirectDependingOnStatus();
        });
      } else if (!emailData) {
        showTechnicalError(() => {
          redirectDependingOnStatus();
        });
      } else if ((emailData === null || emailData === void 0 ? void 0 : emailData.emailStatus) === contactInfoStatus.NOTOFFEREDVERIFICATION || (emailData === null || emailData === void 0 ? void 0 : emailData.emailStatus) === contactInfoStatus.VERIFIED) {
        setIsForbidden(false);
      } else if (await showConfirmEmailDialog()) {
        svs.utils.url.navigate(svs.core.urlMapping.get('myProfileVerifyEmail'));
      } else {
        redirectDependingOnStatus();
      }
      await checkAndShowSyndicateTermsDialogAsync();
    };
    checkEligibility();
  }, [history, hasTeams]);
  if (isForbidden) {
    return null;
  }
  return React.createElement("div", {
    className: "margin-1"
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "main-content-constrained",
    xs: 12,
    sm: {
      col: 10
    },
    am: {
      col: 8
    },
    md: {
      col: 6
    },
    lg: {
      col: 5
    }
  }, createdTeamId === 0 && React.createElement(TeamsCreateName, {
    setCreatedTeamId: setCreatedTeamId
  }), createdTeamId > 0 && React.createElement(TeamsCreateInvite, {
    createdTeamId: createdTeamId
  })))));
};
svs.arena.pages.teams.TeamsCreate = TeamsCreate;

 })(window);